import {Component} from '@angular/core';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-verliesverrekening',
  templateUrl: './tekst-verliesverrekening.component.html',
  styleUrls: ['./tekst-verliesverrekening.component.scss'],
})
export class TekstVerliesverrekeningComponent {}
